import RfiDetails from './RfiDetails.page';

export default RfiDetails;
